












import { Component, Vue, Prop } from 'vue-property-decorator'
import FriendList from '@/components/FriendList.vue'
import RestartButton from '@/components/RestartButton.vue'
import GameOver from '@/components/GameOver.vue'
import GameBoard from '@/components/GameBoard.vue'

@Component({
  components: {
    GameOver,
    GameBoard,
    RestartButton
  }
})
export default class GameOverView extends Vue {
  get selectedFriend () {
    return this.$store.getters['selectedFriend']
  }

  get selectedPresent () {
    return this.$store.getters['selectedPresent']
  }

  get selectedSecretSanta () {
    return this.$store.getters['selectedSecretSanta']
  }

  get error () {
    return this.$store.getters['error']
  }
}
